
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indext8HeiKUKSFxdIBtXW3tyktGpiMhZKURjuSlCJyx_jcMMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/index.vue?macro=true";
import { default as _modaleABQEhUSZm0lhG_sodCGBZKpcPhTdRg8X9Zm8pTXLGYMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/_modal.vue?macro=true";
import { default as policysVO4XWtjJjjwzhZ7dXLyE4_p3FXAiW3V7W3hdOuDkVMMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/policy.vue?macro=true";
import { default as _91url_93fQMxybpB3yuAXf8wCfwHrVHpl1CsUiGeDBWuBwXCRAAMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/news/[url].vue?macro=true";
import { default as indexFnpQO4riQQbf77TrjNkUsOiOaWgJ67WFfmk2Y9Ok_v4Meta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/news/index.vue?macro=true";
import { default as _91url_93_MTlROLukmFApwSkvMMNy0JudvL0bPE7t0IJzgHB4jAMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/service/[url].vue?macro=true";
import { default as index6Ql5uzBuOUm0Wrb7uAicWpm1Lfka_45UexYw6rWqB1qwsMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/service/index.vue?macro=true";
import { default as _91url_93Nd6PUVl0I2iDTcslTSZKWgDDl8p8CJuHnG1JPfQM32sMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/projects/[url].vue?macro=true";
import { default as index1ULHqKy6tJRTo1Pom_45xXQFCcCBh1yZGcTSFxUuZigu4Meta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/projects/index.vue?macro=true";
import { default as _91url_93_P1XvjyddzJ_45iX4eR9ypeJpN_458hbhcGrlulGIs2W_45_45MMeta } from "C:/projects/vite/nuxtjs/BGT/svet/pages/projects/avto/[url].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/index.vue")
  },
  {
    name: "_modal",
    path: "/_modal",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/_modal.vue")
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/policy.vue")
  },
  {
    name: "news-url",
    path: "/news/:url()",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/news/[url].vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/news/index.vue")
  },
  {
    name: "service-url",
    path: "/service/:url()",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/service/[url].vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/service/index.vue")
  },
  {
    name: "projects-url",
    path: "/projects/:url()",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/projects/[url].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/projects/index.vue")
  },
  {
    name: "projects-avto-url",
    path: "/projects/avto/:url()",
    component: () => import("C:/projects/vite/nuxtjs/BGT/svet/pages/projects/avto/[url].vue")
  }
]